import { firstTouchParams } from './attribution';
import { normalizeCtaId } from './sanitize';

const PORTAL_ORIGIN = (
  process.env.REACT_APP_DEVELOPER_PORTAL_URL || 'https://developers.coinversa.ai'
).replace(/\/+$/, '');

export const PLANS = ['starter', 'agent', 'pro', 'enterprise'];
export const SURFACES = ['website', 'explorer'];

export function campaignFor(surface) {
  return surface === 'explorer' ? 'pulse_explorer' : 'developer_signup';
}

/**
 * Conversion links bypass the marketing page. Informational navigation stays
 * on /developers. Keep the auth contract shared by every conversion surface.
 *
 * Internal referral (contract §4): `cv_ref_src` is the CTA id and equals the
 * `cta_clicked.cta_id` fired for the same click; `utm_*` is never used on this
 * internal link, so the visitor's real external acquisition is not
 * overwritten by www → portal navigation.
 *
 * `firstTouch` is the landing site's sanitized first touch. Callers pass it
 * ONLY when analytics consent is granted at click time (see ctaClick in
 * ./analytics.js); it is forwarded as bounded, re-validated `cv_ft_*` params.
 * No raw URL, query string or referrer is ever forwarded.
 */
export function developerSignupUrl(ctaId, { surface = 'website', plan, firstTouch } = {}) {
  const safeSurface = SURFACES.includes(surface) ? surface : 'website';
  const params = new URLSearchParams({ auth: 'signup', next: 'keys' });
  const src = normalizeCtaId(ctaId);
  if (src) params.set('cv_ref_src', src);
  params.set('cv_ref_surface', safeSurface);
  params.set('cv_ref_campaign', campaignFor(safeSurface));
  if (firstTouch) {
    for (const [key, value] of Object.entries(firstTouchParams(firstTouch))) {
      params.set(key, value);
    }
  }
  if (PLANS.includes(plan)) params.set('plan', plan);
  return `${PORTAL_ORIGIN}/?${params.toString()}`;
}
